export const introPopupSplits = ['gfhDptPaidFlow', 'gfhDptTrialUsers'];
export const smartLockSplit = 'gfhSmartLocksNew';
export const smartLockLegacySplit = 'gfhSmartlocksLegacy';
export const gfhSmartLocksDiconectionflow = 'gfhSmartLocksDiconectionflow';
export const gfhIsUserInTrialGLM = 'gfhIsUserInTrialGLM';

export default {};
